define("Widgets/ParallaxScroll", [`Controller`, `module`], (Super, { id: namespace }) =>
	Super.inherit({
		namespace,
		requires: [`App`, `XHR`],
		defaults: {
			loadStylesheet: true,
			scrollWrapper: document.getElementById(`site`),
			resistance: 0.5,
		},
		constructor(setup) {
			const { scrollWrapper, resistance } = setup;
			const { data, elements } = this;
			const content = this.get(`.parallax`);
			const hidden = false;

			this.assign(data, { hidden, resistance });
			this.assign(elements, { content, scrollWrapper });

			this.addClass(`ParallaxScroll positioning`);
		},
		api: {
			calculateDimensions: {
				debounce: 100,
				value() {
					const VIEWPORT_BUFFER = 300; // how many pixels outside the viewport to flip content to display: none
					const { DOM, data, dimensions: containerDimensions, elements } = this;
					const { content, scrollWrapper } = elements;
					const siteDimensions = DOM.getDimensions(scrollWrapper);
					const viewportDimensions = DOM.getViewportDimensions();
					const { resistance } = data;
					const { height: viewportHeight } = viewportDimensions;
					const { scrollHeight: siteHeight } = siteDimensions;
					const { bottom, height, top } = containerDimensions;
					// max scrollTop value, #site scrolled all the way down
					const maxSiteScroll = siteHeight - viewportHeight;
					// pixels scrolled until container is above the viewport
					const maxScroll = bottom;
					// pixels scrolled when container is first visible (start of parallax range)
					const scrollStart = top < viewportHeight ? 0 : top - viewportHeight;
					// end of parallax range, either above viewport or site max
					const scrollEnd = maxScroll >= maxSiteScroll ? maxSiteScroll : maxScroll;
					// the number of scrollable pixels where the module is in viewport
					const scrollRange = scrollEnd - scrollStart;
					// maximum scroll range with the module fully visible (not partially off the top or bottom)
					const maxInnerScrollRange = viewportHeight - height;
					// measure the range if it's smaller than the max
					const measuredInnerScrollRange = scrollRange - height;
					// use whichever is smaller
					const innerScrollRange = this.min([maxInnerScrollRange, measuredInnerScrollRange]);
					// calculate how much extra visible space will be necessary to span the scroll range
					const buffer = innerScrollRange >= 0 ? this.parseInt(innerScrollRange * resistance) : 0;
					// calculate what the initial value should be
					const offset = bottom > viewportHeight ? this.parseInt(bottom - viewportHeight) : 0;

					content.style.top = `-${buffer}px`;

					this.assign(data, {
						scrollEnd: scrollEnd + VIEWPORT_BUFFER,
						scrollStart: scrollStart - VIEWPORT_BUFFER,
						offset,
					});
				},
			},
			onScroll: {
				value({ scrollTop }) {
					const { data, elements } = this;
					const { content } = elements;
					const { scrollEnd, scrollStart } = data;

					if (scrollTop < scrollStart || scrollTop > scrollEnd) {
						if (!data.hidden) {
							content.style.display = `none`;
							data.hidden = true;
							this.defer({
								duration: 20,
								done: true,
								then: this.calculateDimensions,
							});
						}
					} else {
						const { offset, resistance } = data;
						const adjustedScrollTop = scrollTop - offset;
						const yOffset = Math.floor(adjustedScrollTop * resistance);
						const transform = `translate3d(0, ${yOffset}px, 0)`;

						if (transform !== data.transform) {
							content.style.transform = transform;
							data.transform = transform;
						}

						if (data.hidden) {
							content.style.display = ``;
							data.hidden = false;
							this.defer({
								duration: 20,
								done: true,
								then: this.calculateDimensions,
							});
						}
					}
				},
			},
		},
		listeners: [
			{
				trigger: `visible`,
				handler() {
					const { App } = this;

					this.defer({
						done: true,
						then: this.calculateDimensions,
					});

					this.defer({
						done: true,
						duration: 100,
						then: this.calculateDimensions,
					});

					this.defer({
						done: true,
						duration: 500,
						then: () => {
							this.calculateDimensions();
							this.removeClass(`positioning`);

							// subscribe to scroll updates, and fire immediately
							App.onScroll(this.onScroll, true);
						},
					});

					this.defer({
						done: true,
						duration: 2000,
						then: this.calculateDimensions,
					});
				},
			},
			{
				event: `resize`,
				target: window,
				matchContainer: false,
				handler(evt) {
					return this.calculateDimensions();
				},
			},
		],
	}));

//# sourceMappingURL=ParallaxScroll.js.map